import React from 'react'
import PropTypes from 'prop-types'
import { Copy, themeColor, themeFontSize, themeFontWeight, themeFontFamily } from '@elparking/components'
import styled from 'styled-components'

const mainColor = themeColor('main')
const grayColor = themeColor('lightGray20')

const borderColorStyledItem = ({selected}) => selected
    ? 'transparent'
    : themeColor('gray')

const backgroundPosition = ({selected}) => selected
    ? 'center bottom'
    : 'left bottom'

const backgroundPositionLast = ({selected}) => selected
    ? 'center bottom'
    : 'right bottom'

const colorStyledItem = ({selected}) => selected
    ? themeColor('white')
    : themeColor('gray')

const marginNoSelected = ({selected}) => selected
    ? '16px'
    : '0'

const shadowSelected = (props) => props.selected
    ? `0px 0px 8px 0px ${themeColor('lightGray80')(props)}`
    : 'none'

const borderRadiusLeftSelected = ({selected}) => selected
    ? `16px`
    : '16px 0 0 16px'

const borderRadiusRightSelected = ({selected}) => selected
    ? `16px`
    : '0 16px 16px 0'

const StyledParkingItem = styled.button`
    position: relative;
    cursor: pointer;
    outline: none;
    color: ${colorStyledItem};
    background: linear-gradient(to right, ${grayColor} 0%, ${grayColor} 33%, ${mainColor} 33%, ${mainColor} 67%, ${grayColor} 67%);
    background-size: 310% 100%;
    background-position: ${backgroundPosition};
    border: none;
    box-shadow: ${shadowSelected};
    padding: 8px 16px;
    height: 32px;
    font-size: ${themeFontSize('xxSmall')};
    font-weight: ${themeFontWeight('book')};
    font-family: ${themeFontFamily()};
    text-align: center;
    overflow: visible;
    letter-spacing: 0px;
    &:first-child {
        border-right: 0;
        border-radius: ${borderRadiusLeftSelected};
    }
    &:last-child {
        border-left: 0;
        border-radius: ${borderRadiusRightSelected};
    }
    padding: 0;
`
StyledParkingItem.propTypes = {
    selected: PropTypes.bool,
}

const SwitcherContainer = styled(Copy)`
    position: relative;
    padding: 0;
    display: flex;
    border: 1px solid ${borderColorStyledItem};
    border-radius: 25px;
`
const StyledItem1 = styled(StyledParkingItem)`
    border-right: 0;
    border-radius: ${borderRadiusLeftSelected};
    padding-left: 16px;
    padding-right: ${marginNoSelected};
    margin: 0;
`

const StyledItem2 = styled(StyledParkingItem)`
    background-position: ${backgroundPositionLast};
    margin-left: 16px;
    padding-right: 16px;
    padding-left: ${marginNoSelected};
    margin-right: 0;
    &:hover {
        background-position: ${backgroundPositionLast};
    }
`

const Checked = ({ children, type, selected, onChange, element: Element }) => (
    <Element
      selected={type === selected}
      onClick={() => onChange(type)}
    >
        {children}
    </Element>
)

Checked.propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
    selected: PropTypes.string,
    type: PropTypes.string,
    element: PropTypes.object,
}

export {
    Checked,
    StyledItem1,
    StyledItem2,
}

const Switcher = ({ onChange, selected, primaryOption, secondaryOption }) => {
    const value = selected || primaryOption.value
    return <SwitcherContainer as='span'>
        <Checked element={StyledItem1} type={primaryOption.value} selected={value} onChange={onChange}>
            {primaryOption.label}
        </Checked>
        <Checked element={StyledItem2} type={secondaryOption.value} selected={value} onChange={onChange}>
            {secondaryOption.label}
        </Checked>
    </SwitcherContainer>
}

Switcher.propTypes = {
    onChange: PropTypes.func,
    selected: PropTypes.string,
    primaryOption: PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.node,
    }).isRequired,
    secondaryOption: PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.node,
    }).isRequired,
}

Switcher.defaultProps = {
    onChange: () => {},
}

export default Switcher
